import React, { Fragment, useState } from "react";
import { ArrowRepeat, Plus, Trash } from "react-bootstrap-icons";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/24/outline";
import { v4 as uuidv4 } from "uuid";
const uuid = uuidv4();
const OneChoiceGenerator = ({ openModal }) => {
  const [question, setQuestion] = useState("");
  const [choices, setChoices] = useState(["", "", "", ""]);

  const [selected, setSelected] = useState(choices[0]);

  const [answerIndex, setAnswerIndex] = useState(0);
  const [correctMessageDE, setCorrectMessageDE] = useState("");
  const [wrongMessageDE, setWrongMessageDE] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      question,
      choices,
      answerIndex: parseInt(answerIndex),
      /* correctMessageDE,
      wrongMessageDE,*/
    };

    const result =
      `<div id="${uuid}" />` +
      "<p><OneChoice data={" +
      JSON.stringify(data) +
      "}/></p> ";
    openModal(result);
  };

  const handleChoiceChange = (index, value) => {
    const updatedChoices = [...choices];
    updatedChoices[index] = value;
    setChoices(updatedChoices);
  };
  //const [selectedOption, setSelectedOption] = useState(choices[0]);

  const handleOptionChange = (value) => {
    const index = choices.findIndex((item) => {
      return item === value;
    });
    setSelected(value);
    setAnswerIndex(index);
    // const option = event.target.value;
    //const optionIndex = event.target.selectedIndex;
    //setSelectedOption(option);
  };

  const addChoice = () => {
    setChoices([...choices, ""]);
    console.log(choices);
  };

  const deleteChoice = (id) => {
    if (choices.length >= 3) {
      setChoices([...choices.slice(0, id), ...choices.slice(id + 1)]);
    } else {
    }
  };
  return (
    <>
      <div className="grid  m-auto p-2">
        <form
        //  onSubmit={handleSubmit}
        //     className=" mx-auto mt-6 p-6 bg-white rounded-lg shadow-md "
        >
          <div className="flex flex-col gap-6 ">
            <div className="mb-4">
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="question"
              >
                Question
              </label>
              <input
                className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="question"
                type="text"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                placeholder="Write your question here."
              />
            </div>

            <div className="my-2 ">
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="Choices"
              >
                Choices
              </label>
              {choices.map((choice, index) => (
                <div className="mb-4">
                  <label
                    //className="flex w-full h-full select-none pointer-events-none absolute left-0 font-normal !overflow-visible truncate peer-placeholder-shown:text-blue-gray-500 leading-tight peer-focus:leading-tight peer-disabled:text-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500 transition-all -top-1.5 peer-placeholder-shown:text-sm text-[11px] peer-focus:text-[11px] before:content[' '] before:block before:box-border before:w-2.5 before:h-1.5 before:mt-[6.5px] before:mr-1 peer-placeholder-shown:before:border-transparent before:rounded-tl-md before:border-t peer-focus:before:border-t-2 before:border-l peer-focus:before:border-l-2 before:pointer-events-none before:transition-all peer-disabled:before:border-transparent after:content[' '] after:block after:flex-grow after:box-border after:w-2.5 after:h-1.5 after:mt-[6.5px] after:ml-1 peer-placeholder-shown:after:border-transparent after:rounded-tr-md after:border-t peer-focus:after:border-t-2 after:border-r peer-focus:after:border-r-2 after:pointer-events-none after:transition-all peer-disabled:after:border-transparent peer-placeholder-shown:leading-[3.75] text-blue-gray-400 peer-focus:text-blue-500 before:border-blue-gray-200 peer-focus:before:!border-blue-500 after:border-blue-gray-200 peer-focus:after:!border-blue-500">
                    className="text-xs block text-gray-400 font-bold mb-2"
                  >
                    {"Choice " + index}
                  </label>
                  <div className="flex gap-2">
                    <input
                      type="text"
                      key={index}
                      value={choice}
                      onChange={(e) =>
                        handleChoiceChange(index, e.target.value)
                      }
                      className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                      placeholder=" "
                    />
                    <button type="reset" onClick={() => deleteChoice(index)}>
                      <Trash className="text-red-500" size={20} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <button
              className=" btn btn-circle  m-auto "
              onClick={addChoice}
              type="reset"
            >
              <Plus size={30} />
            </button>

            {/**    <div className="mb-4">
              <label htmlFor="correctAnswerSelect" className="text-sm">
                Select the correct choice.
              </label>
              <select
                id="correctAnswerSelect"
                value={selectedOption}
                onChange={handleOptionChange}
                className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              >
                {choices.map((choice, index) => (
                  <option
                    index={index}
                    className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                    value={choice}
                  >
                    {choice}
                  </option>
                ))}
              </select>
            </div>*/}
            <div className="mb-4 ">
              <label
                htmlFor="correctAnswerSelect"
                className="text-sm block text-gray-700 font-bold mb-2"
              >
                Select the correct choice.
              </label>
              <Listbox value={selected} onChange={handleOptionChange}>
                <div className="relative  mt-1">
                  <Listbox.Button className="relative h-10 w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left shadow-md focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-orange-300 sm:text-sm">
                    <span className="block truncate">{selected}</span>
                    <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                      <ChevronUpDownIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </span>
                  </Listbox.Button>
                  <Transition
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Listbox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm">
                      {choices.map((choice, index) => (
                        <Listbox.Option
                          key={index}
                          className={({ active }) =>
                            `relative cursor-default select-none py-2 pl-10 pr-4 ${
                              active
                                ? "bg-amber-100 text-amber-900"
                                : "text-gray-900"
                            }`
                          }
                          value={choice}
                        >
                          {({ selected }) => (
                            <>
                              <span
                                className={`block truncate pointer-events-none ${
                                  selected ? "font-medium" : "font-normal"
                                }`}
                              >
                                {choice}
                              </span>
                              {selected && choice !== "" ? (
                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-amber-600">
                                  <CheckIcon
                                    className="h-5 w-5"
                                    aria-hidden="true"
                                  />
                                </span>
                              ) : null}
                            </>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Transition>
                </div>
              </Listbox>
            </div>
            {/**      <div className="mb-4">
              {" "}
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="correctMessageDE"
              >
                Correct Message (DE):
              </label>
              <input
                className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                id="correctMessageDE"
                value={correctMessageDE}
                onChange={(e) => setCorrectMessageDE(e.target.value)}
                placeholder=" "
              />
            </div>
            <div className="mb-4">
              {" "}
              <label
                className="text-sm block text-gray-700 font-bold mb-2"
                htmlFor="wrongMessageDE"
              >
                Wrong Message (DE):
              </label>
              <input
                className="text-sm shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="text"
                id="wrongMessageDE"
                value={wrongMessageDE}
                onChange={(e) => setWrongMessageDE(e.target.value)}
                placeholder=" "
              />
            </div>*/}

            <div className="flex flex-row m-auto mt-4">
              <button
                onClick={handleSubmit}
                id="submitButton"
                key="submitButton"
                type="submit"
                className=" btn    m-auto mx-4  "
              >
                Create Question
              </button>
              <button
                id="resetButton"
                key="resetButton"
                type="reset"
                onClick={() => {
                  setAnswerIndex(0);
                  setQuestion("");
                  setChoices(["", "", "", ""]);
                  setCorrectMessageDE("");
                  setWrongMessageDE("");
                  setSelected("");
                }}
                className=" btn btn-circle   m-auto  "
              >
                <ArrowRepeat size={30} />
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default OneChoiceGenerator;
